import * as TimerActionTypes from '../actiontypes/timer';

export const setNextAvailable = time => ({
  type: TimerActionTypes.SET_TIMER_NEXT_AVAILABLE,
  nextAvailable: time,
});

export const setRemaining = time => ({
  type: TimerActionTypes.SET_TIMER_REMAINING,
  timeRemaining: time,
});
